<ng-container [formGroup]="fg">
  <label
    appConfigSettingsParagraph
    class="displayInLine"
    [style.color]="fontColor ? fontColor : null"
    [style.font-size.px]="fontSize ? fontSize : null"
  >
    <p>
      {{ placeholder | translate }}
    </p>
    <div
      *ngIf="additionalInfoInsurer!=null"
    >
      <mat-icon class="infoIcon" (click)="openPopup()" type="button">info</mat-icon>
    </div>
  </label>
  <div class="input-container">
    <input
      [type]="type"
      placeholder="{{ showPlaceholder ? (placeholder | translate) : '' }}"
      [formControl]="control"
      [required]="isRequired"
      [mask]="inputMask"
      [thousandSeparator]="thousandSeparator"
      [showMaskTyped]="showMaskTyped"
      [placeHolderCharacter]="placeHolderCharacter"
      [pattern]="pattern"
      [attr.uppercase]="uppercase ? '' : null"
      [attr.capitalize]="capitalize ? '': null"
      [prefix]="prefix"
      [suffix]="suffix"
      [dropSpecialCharacters]="dropSpecialCharacters"
      appConfigSettingsBorder
      appConfigSettingsInput
      [style.borderColor]="inputBorderColor ? inputBorderColor : null"
      [style.color]="inputColor ? inputColor : null"
      [readonly]="isDisabled"
    />

    <img alt="calculator" *ngIf="isCalculatorShown" class="calculator" src="./assets/images/calculator.png" (click)="showCalculator()" />

    <div class="input-loader" *ngIf="isLoaderShown">
      <mat-progress-spinner
        class="spinner"
        color="primary"
        mode="indeterminate"
        value="100"
        diameter="20"
      ></mat-progress-spinner>
    </div>

    <mat-error *ngIf="isAnyError" class="error-message">
      <ng-container *ngIf="control.errors?.message">
        {{ control.errors.message }}
      </ng-container>
      <ng-container *ngIf="control.errors?.required">
        {{ isRequiredMessage }}
      </ng-container>
      <ng-container *ngIf="control.errors?.max">
        {{ "Common.MaxSumAssured"| translate }}
      </ng-container>
      <ng-container *ngIf="control.errors?.iban">
        {{ "Common.IbanInvalidValidationMessage" | translate }}
      </ng-container>
      <ng-container *ngIf="control.errors?.mustMatch">
        {{ "Common.InvalidConfirmationEmailMessage" | translate }}
      </ng-container>
    </mat-error>
  </div>
</ng-container>
